import {ApiRequest, RequestMethod} from "../../../request";

export type UpdateTraitResult = {
    id: string;
    name: string;
    description: string;
    commonStatus: number;
};

export async function updateTrait(
    id: string,
    data: { name: string; description: string }
): Promise<UpdateTraitResult | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/weapon-trait/${id}`);
    apiRequest.setJsonBody(data);

    const response: any = await apiRequest.send();

    if (response.status === 200) {
        return {
            id: response.data["id"],
            name: response.data["name"],
            description: response.data["description"],
            commonStatus: response.data["commonStatus"],
        };
    }

    return null;
}